// POS Terminal — real API, product search, cart, payment
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
const products = () => fetch("/api/v1/product.product",{headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"}}).then(r=>r.json()).then((r:any)=>r.ok?r.data:[]);
const createSession = () => fetch("/api/v1/pos.session",{method:"POST",headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"},body:JSON.stringify({name:`Session-${Date.now()}`})}).then(r=>r.json()).then((r:any)=>r.ok?r.data:null);
const createOrder = (d:any) => fetch("/api/v1/pos.order",{method:"POST",headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"},body:JSON.stringify(d)}).then(r=>r.json()).then((r:any)=>r.ok?r.data:null);
const payOrder = (id:number,am:number) => fetch(`/api/v1/pos.order/${id}/pay`,{method:"POST",headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"},body:JSON.stringify({amountPaid:am})});

export default function PosPage() {
  const { data: allProducts } = useQuery({ queryKey: ["pos-products"], queryFn: products });
  const [session, setSession] = useState<any>(null);
  const [cart, setCart] = useState<{productId:number;name:string;price:number;qty:number}[]>([]);
  const [search, setSearch] = useState("");
  const [paid, setPaid] = useState(false);

  useEffect(() => { createSession().then(s => setSession(s)); }, []);

  const filtered = allProducts?.filter((p:any) => !search || p.name?.toLowerCase().includes(search.toLowerCase())) ?? [];
  const total = cart.reduce((s,i) => s + i.price * i.qty, 0);

  const addItem = (p:any) => {
    const ex = cart.find(c => c.productId === p.id);
    if (ex) setCart(cart.map(c => c.productId === p.id ? {...c, qty: c.qty + 1} : c));
    else setCart([...cart, { productId: p.id, name: p.combinedName ?? p.name, price: p.list_price ?? 0, qty: 1 }]);
  };

  const checkout = async () => {
    if (!session || cart.length === 0) return;
    const order = await createOrder({ name: `POS-${Date.now()}`, sessionId: session.id, state: "draft", amountTotal: total });
    if (order?.id) {
      await payOrder(order.id, total);
      setPaid(true);
      setTimeout(() => { setCart([]); setPaid(false); }, 2000);
    }
  };

  return <div className="flex gap-6 h-[calc(100vh-6rem)]">
    <div className="flex-1 flex flex-col">
      <div className="bg-white rounded-xl shadow-sm border p-4 mb-4">
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search products..." className="w-full border rounded-lg px-4 py-3 text-lg outline-none focus:ring-2 focus:ring-blue-500" autoFocus />
      </div>
      <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-3 overflow-auto pb-4">
        {filtered.map((p:any) => <button key={p.id} onClick={() => addItem(p)} className="bg-white rounded-xl shadow-sm border p-4 text-left hover:shadow-md hover:border-blue-300 transition-all">
          <div className="bg-gray-50 rounded-lg h-20 mb-2 flex items-center justify-center text-3xl">📦</div>
          <p className="font-medium text-sm truncate">{p.combinedName ?? p.name}</p>
          <p className="text-blue-600 font-bold mt-1">${(p.list_price ?? 0).toFixed(2)}</p>
        </button>)}
        {filtered.length === 0 && <p className="text-gray-400 col-span-4 text-center py-8">{search ? "No products found" : "Loading products..."}</p>}
      </div>
    </div>

    <div className="w-80 bg-white rounded-xl shadow-sm border p-5 flex flex-col">
      <h3 className="font-bold text-lg mb-3">{session ? `Session #${session.id}` : "Loading..."} · {cart.length} items</h3>
      <div className="flex-1 space-y-2 overflow-auto max-h-96">
        {cart.map((item,idx) => <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg text-sm">
          <div className="flex-1"><p className="font-medium truncate">{item.name}</p><div className="flex items-center gap-2 mt-1">
            <button onClick={()=>setCart(cart.filter((_,i)=>i!==idx))} className="text-red-500 text-xs">✕</button>
            <span className="text-gray-500">x{item.qty}</span>
          </div></div>
          <span className="font-semibold">${(item.price*item.qty).toFixed(2)}</span>
        </div>)}
        {cart.length === 0 && <p className="text-gray-400 text-center py-8 text-sm">{paid ? "✅ Payment complete!" : "Tap products to add"}</p>}
      </div>
      <div className="border-t pt-3 mt-3 space-y-3">
        <div className="flex justify-between text-lg font-bold"><span>Total</span><span>${total.toFixed(2)}</span></div>
        <button onClick={checkout} disabled={cart.length===0||!session}
          className="w-full py-3 bg-green-600 text-white rounded-xl font-bold text-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed">
          Pay ${total.toFixed(2)}
        </button>
      </div>
    </div>
  </div>;
}
